export default {
  apiURL: '/api/v1/',
  resizerURL: '//img.indemandly.com/',
  widgetPageURL: 'https://[DOMAIN].indemand.ly/',
  widgetLauncherURL: 'https://widget.indemand.ly/launcher.js',
  stripeKey: 'pk_live_Qx1jeL4p4kV4y505dm5I6f9I',
  agreementVersion: 1,
}

